var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-overlay',{model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"40"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }